// The build configuration in `angular.json` will replace `environment.prod.ts`
// with this file when the following command is run:
// `ng build --configuration production`

export const environment = {
    production: true,
    baseUrl: '/fc-services-public/api/v1',
    baseUrlV3: '/fc-services-public/api/v3',
};
